module.exports = __webpack_public_path__ + "media/src/images/icon__magazinHappy3-edc4e65705c623627e99fc778030f69a.svg";